export default "__VITE_ASSET__D5QdTQGk__"